import "./Spinner.css";

interface SpinnerProps {
	size?: "small" | "medium" | "large";
	className?: string;
}

export const Spinner = ({ size = "medium", className = "" }: SpinnerProps) => {
	return <div className={`spinner spinner-${size} ${className}`} />;
};

export const LoadingScreen = () => {
	return (
		<div className="spinner-container">
			<Spinner size="large" />
		</div>
	);
};
